
import { axios } from "~/plugins/request"

export function generationScheme(data) {
  return axios({
    method: 'post',
		url: '/art/smartReport/generationScheme',
    data: data
  })
}

export function findAllSpecialityCategoryAndSpeciality(data) {
  return axios({
    method: 'get',
		url: '/art/smartReport/findAllSpecialityCategoryAndSpeciality',
    params: data
  })
}

export function findAllProvince() {
  return axios({
    method: 'get',
		url: '/art/smartReport/findAllProvince',
  })
}

export function findAllBatchByProvinceId(data) {
  return axios({
    method: 'get',
    url: '/art/smartReport/findAllBatchByProvinceId',
    params: data
  })
}

export function findSpecialityType(data) {
  return axios({
    method: 'get',
    url: '/art/smartReport/findSpecialityType',
    params: data
  })
}
